import React, { useState, useEffect } from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import moment from 'moment';

import Searchbar from '../../../components/Searchbar';
import { newFetch, GET } from '../../../helpers/fetch';
import { Spinner } from 'reactstrap';

const Events = ({ history }) => {
  const clientID = parseInt(localStorage.getItem('client'), 10);
  const [events, setEvents] = useState([]);
  const [client, setClient] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  const sortDateAndTimeDesc = (a, b) => {
    if (moment(a.createdAt).isSameOrBefore(moment(b.createdAt))) return 1;
    else return -1;
  };

  const fetchEvents = async () => {
    setLoading(true);
    let api_path = `/event/client/${clientID}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let eventsData = response.data.sort(sortDateAndTimeDesc);
      setEvents(eventsData);
      setFilteredEvents(eventsData);
    } else {
      setEvents([]);
      setFilteredEvents([]);
    }
    setLoading(false);
  };

  const fetchClientById = async () => {
    setLoading(true);

    const api_path = `/client/${clientID}`;
    const response = await newFetch(GET, api_path);

    if (response.success) {
      const clientData = response.data;
      setClient(clientData);
    }
    setLoading(false);
  };

  const handleSearch = (e) => {
    let filtered = [...events].filter((event) => {
      return (
        event.title.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1
      );
    });

    setFilteredEvents(filtered);
  };

  useEffect(() => {
    fetchEvents();
    fetchClientById();
  }, []);

  useEffect(() => {
    fetchEvents();
    fetchClientById();
  }, [clientID]);

  return (
    <div
      className="container-fluid"
      style={{
        paddingLeft: '2rem',
        paddingRight: '2rem',
        paddingBottom: '6rem',
      }}
    >
      <div className="border-bottom pb-3 py-2 d-flex align-items-center">
        <h6 className="flex-grow-1 pt-4" style={{ color: '#5156BE' }}>
          Events
        </h6>
        {client.enable_event && (
          <NavLink
            to={`/events/add`}
            className="text-decoration-none"
            style={{ color: 'inherit' }}
          >
            <button
              className="btn btn-outline-brand ms-3 mt-2 adjust-fs adjust-shadow"
              style={{ width: '200px' }}
            >
              Add New
            </button>
          </NavLink>
        )}
      </div>
      {client.enable_event ? (
        <>
          <div className="d-flex flex-row align-items-center py-3">
            <h6 className="flex-grow-1">
              Events{' '}
              {clientID === 0 || (client && client?.enable_event === true)
                ? `(${filteredEvents.length})`
                : '(0)'}
            </h6>
            <Searchbar
              search={(e) => handleSearch(e)}
              placeholder="Search events"
            />
          </div>
          <div className="table-responsive rounded shadow bg-white">
            <table className="table table-borderless mb-0">
              <thead className="border-bottom">
                <tr>
                  <th className="py-3 text-muted fw-normal px-3">ID</th>
                  <th className="py-3 text-muted fw-normal px-3">
                    Event Title
                  </th>
                  <th className="py-3 text-muted fw-normal px-3">Client</th>
                  <th className="py-3 text-muted fw-normal text-center px-3">
                    Date Created
                  </th>
                </tr>
              </thead>
              {loading ? (
                <tbody>
                  <tr>
                    <td colSpan={4} className="text-center py-12">
                      <div className="flex justify-center items-center">
                        <Spinner />
                      </div>
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody>
                  {clientID === 0 ||
                  (client && client?.enable_event) === true ? (
                    filteredEvents.length > 0 ? (
                      filteredEvents.map((event) => (
                        <tr
                          key={event?.id}
                          onClick={() =>
                            history.push(`/events/event/${event?.id}`)
                          }
                          className="cursor-pointer hover:bg-gray-50 transition-colors"
                        >
                          <td
                            width="10%"
                            style={{ verticalAlign: 'middle' }}
                            className="p-3 text-muted"
                          >
                            {event?.event_id}
                          </td>
                          <td className="p-3">
                            <div className="d-flex flex-column">
                              <strong className="text-muted">
                                {event?.title}
                              </strong>
                              <div className="mt-1 text-muted">
                                {event?.description}
                              </div>
                            </div>
                          </td>
                          <td
                            width="20%"
                            style={{ verticalAlign: 'middle' }}
                            className="p-3 text-muted"
                          >
                            {event?.client?.name}
                          </td>
                          <td
                            width="15%"
                            className="text-center p-3 text-muted"
                            style={{ verticalAlign: 'middle' }}
                          >
                            {moment(event?.createdAt).format('DD MMMM YYYY')}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center py-4">
                          <div className="flex flex-col items-center p-6">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="mb-2 text-gray-400"
                            >
                              <rect
                                width="18"
                                height="18"
                                x="3"
                                y="3"
                                rx="2"
                                ry="2"
                              ></rect>
                              <line x1="8" y1="12" x2="16" y2="12"></line>
                            </svg>
                            <p className="text-gray-500 text-muted">
                              No events found
                            </p>
                          </div>
                        </td>
                      </tr>
                    )
                  ) : (
                    <tr>
                      <td colSpan={4} className="text-center py-4">
                        <div className="flex flex-col items-center p-6">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="mb-2 text-gray-400"
                          >
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" y1="8" x2="12" y2="12"></line>
                            <line x1="12" y1="16" x2="12.01" y2="16"></line>
                          </svg>
                          <p className="text-gray-500 text-muted">
                            Events module not enabled for this client
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              )}
            </table>
          </div>
        </>
      ) : (
        <div className="text-muted pt-4">
          The client does not have access to this module.
        </div>
      )}
    </div>
  );
};

export default withRouter(Events);
